import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { SessionsResponse } from '@/types/api';

export function useSessions() {
  return useQuery({
    queryKey: ['auth', 'sessions'],
    queryFn: () => apiFetch<SessionsResponse>('/auth/sessions.php'),
    retry: false,
    staleTime: 30_000
  });
}
